var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"anchor text-link",on:{"click":_vm.handleClickToGenerateLink}},[_vm._v(_vm._s(_vm.readableName()))])])}
var staticRenderFns = []

export { render, staticRenderFns }